import React, { useEffect, useState, useCallback } from 'react';
import { ChevronDown, Sparkles } from 'lucide-react';
import { heroImage, logoWhite } from '../mock';

const Hero = () => {
  const [scrollY, setScrollY] = useState(0);

  const handleScroll = useCallback(() => {
    setScrollY(window.scrollY);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const scrollDown = useCallback(() => {
    document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <section
      id="home"
      className="relative min-h-screen w-full flex items-center justify-center overflow-hidden bg-black pt-20 pb-16"
    >
      <div
        className="absolute inset-0 bg-cover bg-center will-change-transform"
        style={{
          backgroundImage: `url(${heroImage})`,
          transform: `translateY(${scrollY * 0.25}px) scale(1.05)`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/45 to-black/85" />
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
        }}
      />

      <div
        className="relative z-10 text-center px-6 max-w-5xl mx-auto w-full"
        style={{ transform: `translateY(${scrollY * -0.08}px)` }}
      >
        <div
          className="inline-flex items-center gap-3"
          style={{ animation: 'fadeUp 1s ease 0.1s both' }}
        >
          <Sparkles size={14} className="text-[#f6c878]" />
          <span className="text-[#f6c878] tracking-[0.4em] text-[11px] md:text-[13px] font-semibold">
            THE UK'S PREMIER TRIBUTE BAND
          </span>
          <Sparkles size={14} className="text-[#f6c878]" />
        </div>

        <div
          className="flex items-center justify-center mt-5 md:mt-7"
          style={{ animation: 'fadeUp 1.2s ease 0.25s both' }}
        >
          <img
            src={logoWhite}
            alt="The Fleetwood Mac Experience"
            className="w-full max-w-[520px] md:max-w-[660px] h-auto drop-shadow-[0_4px_30px_rgba(0,0,0,0.6)]"
          />
        </div>

        <p
          className="mt-5 md:mt-7 text-white/90 text-[15px] md:text-[18px] max-w-2xl mx-auto font-light leading-relaxed"
          style={{ animation: 'fadeUp 1s ease 0.5s both' }}
        >
          Sing along, dance along — a joyful live theatre show celebrating the
          timeless music of Fleetwood Mac.
        </p>

        <div
          className="mt-6 md:mt-8 flex items-center justify-center gap-4 text-white/50 text-[11px]"
          style={{ animation: 'fadeUp 1s ease 0.7s both' }}
        >
          <span>✦</span>
          <span>✦</span>
          <span>✦</span>
        </div>
      </div>

      <div className="absolute bottom-5 left-0 right-0 z-10 pointer-events-none">
        <div className="max-w-5xl mx-auto w-full px-6 flex justify-center">
          <button
            onClick={scrollDown}
            aria-label="Scroll down"
            className="text-white/70 hover:text-white animate-bounce pointer-events-auto"
          >
            <ChevronDown size={26} strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
